
export enum SnackbarStates{
    LOADING,
    SUCCESS_MESSAGE,
    ERROR_MESSAGE,
    NOTIFICATION,
    INFO,
    NONE
}